<template>
  <div>
    <template v-if="loginState === loginStates.AUTHORIZING">
      <h3>Login läuft</h3>
      <p>Bitte warten...</p>
    </template>
    <template v-else-if="loginState === loginStates.AUTHORIZED">
      <h3>Login erfolgreich</h3>
    </template>
    <template v-else-if="loginState === loginStates.FAILED">
      <h3>Login fehlgeschlagen</h3>
    </template>
  </div>
</template>
<script>
  const axios = require('axios');

  const LOGIN_STATES = {
    AUTHORIZING: 0,
    AUTHORIZED: 1,
    FAILED: 2
  };

  export default {
    data() {
      return {
        loginState: LOGIN_STATES.AUTHORIZING,
        loginStates: LOGIN_STATES
      }
    },
    mounted() {
      axios.post(`${process.env.VUE_APP_API}/auth/token`, {
        code: this.$route.query.code,
        state: this.$route.query.state
      }).then(response => {
        localStorage.setItem('API_CREDENTIALS', JSON.stringify(response.data));
        this.$router.push('/');
      }).catch(err => {
        this.loginState = LOGIN_STATES.FAILED;
      })
    }
  }
</script>
